<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
      :collapse-action="true">
      <div class="vx-row">
        <div class="w-1/3 vx-col">
          <label class="text-sm opacity-100 text-bold">Assessment</label>
          <v-select :clearable="true" v-model="filters['search']" :reduce="option => option"
            :options="['Property Risk Assessment', 'Hazard Inspection', 'Food Safety Report', 'COPE Assessment', 'Action Status Report']" class="w-full">
          </v-select>
        </div>
        <div class="w-1/3 vx-col">
          <label class="text-sm opacity-100 text-bold">Brand</label>
          <v-select :clearable="true" v-model="filters['brand']" :reduce="option => option"
            :options="['victual', 'rm4c']" class="w-full">
          </v-select>
        </div>
      </div>
      <div class="mt-5 vx-row">
        <div class="w-full ml-auto vx-col">
          <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
            v-on:click="filters = {}">CLEAR
          </vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card title="" v-can:any="['view-report-templates', 'update-report-templates']">
      <template slot="actions">
        <div class="flex float-right">
          <div class="con-btns-user flex items-center justify-between">
            <div class="flex mb-4">
              <vs-button v-can="'view-report-templates'" @click="onClickRefresh" class="mr-0" color="success"
                type="border" icon-pack="feather" icon="icon-rotate-cw"></vs-button>
            </div>
          </div>
        </div>
      </template>
      <div slot="no-body" class="mt-4">
        <vs-table id="tenants-table" :data="template_list" :sst="true" stripe
          class="table-dark-inverted table-auto vs-con-loading__container">>

          <template slot="thead">
            <vs-th width="15%">Template Name</vs-th>
            <vs-th width="20%">Description</vs-th>
            <vs-th width="5%">Brand</vs-th>
            <vs-th width="30%">Template Uploaded</vs-th>
            <vs-th width="10%">Updated At</vs-th>
            <vs-th width="10%">Template Uploaded By</vs-th>
            <vs-th width="10%"></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr class="cursor-pointer" @click.native="onClickUpdate(data[indextr])" :key="indextr"
              v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].Name">
                <span class="text-primary"> {{ data[indextr].Name }}</span>
              </vs-td>

              <vs-td :data="data[indextr].Description">
                {{ data[indextr].Description || 'N/A' }}
              </vs-td>

              <vs-td :data="data[indextr].Brand" class="font-bold">
                {{ data[indextr].Brand || 'N/A' }}
              </vs-td>

              <vs-td>
                <vs-chip transparent :color="data[indextr].s3Key ? 'primary' : 'danger'">
                  {{ data[indextr].s3Key ? 'Yes' : 'No' }}
                </vs-chip>
                <span class="ml-4 text-primary font-bold">{{ data[indextr].fileName || '' }}</span>
              </vs-td>

              <vs-td :data="data[indextr].updatedAt">
                {{ __dateTimeFormatter(data[indextr].updatedAt) }}
              </vs-td>

              <vs-td :data="data[indextr].uploadedBy">
                {{ data[indextr].uploadedBy ? data[indextr].uploadedBy.fullName : 'N/A' }}
              </vs-td>


              <vs-td>
                <div class="vx-row">
                  <vx-tooltip v-can="'update-report-templates'" class="mr-2" text="Update Template" position="top">
                    <vs-button @click.stop="onClickUpdate(data[indextr])" size="small" color="warning" type="border"
                      icon-pack="feather" icon="icon-edit-2"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip v-if="data[indextr].s3Key" v-can="'view-report-templates'" class="mr-2"
                    text="View Template" position="top">
                    <vs-button @click.stop="onClickTenantView(data[indextr].s3Key)" size="small" color="success"
                      type="border" icon-pack="feather" icon="icon-download"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>


        </vs-table>

      </div>
    </vx-card>
    <CreateObjectPopUp ref="createObjectPopUp" />
    <UpdateReportTemplatePopUp ref="updateReportTemplatePopUp" />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import vSelect from 'vue-select'
const ReportTemplateRepository = RepositoryFactory.get('report_template')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateObjectPopUp from "@/components/popups/general/CreateObjectPopUp.vue"
import UpdateReportTemplatePopUp from "@/components/popups/report-templates/UpdateReportTemplatePopUp.vue"

export default {
  name: 'TenantList',
  data() {
    return {
      template_list: [],
      filters: {},
    }
  },
  components: {
    'v-select': vSelect,
    CreateObjectPopUp,
    UpdateReportTemplatePopUp
  },
  async mounted() {
    await this.fetchTemplates()
  },
  methods: {
    async refreshData() {
      await this.fetchTemplates()
    },
    async onClickTenantView(s3Key) {
      const downloadUrl = `https://ribu-production.s3.ap-southeast-2.amazonaws.com/${s3Key}`;

      const newTab = window.open(downloadUrl, '_blank');

      // Fallback: If the browser blocks the new tab (for example, if popups are blocked)
      if (!newTab) {
        console.error('Failed to open the file in a new tab. Popups may be blocked.');
      }
    },
    async fetchTemplates() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        const { data } = (await ReportTemplateRepository.fetchReportTemplates(this.filterQuery)).data
        this.template_list = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    async onClickCreateTenant() {
      await this.$refs.createObjectPopUp.openPopup('account', 'create', { OwnerId: this.$store.getters.currentUserId })
    },
    async onClickUpdate(data) {
      await this.$refs.updateReportTemplatePopUp.openPopup(data)
    },
    async onClickRefresh() {
      await this.fetchTemplates()
    },
    filterQueryUpdate() {
      this.fetchTemplates()
    },
  },

  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped></style>
